import { StackView, Spinner, Text } from '@planningcenter/tapestry-react';
import React from 'react';
import { ScrollContainer } from '../../vendor/topbar/components/scroll_container.js';
import { ChildNotice } from '../child_notice.js';
import { NewChatViewFooter } from '../new_chat_view/footer.js';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import '../../chat_context.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { Person } from '../person_list_item.js';
import { Subheading } from '../ui/subheading.js';
import { NEW_SERVICES_CHAT_FOOTER_TEXT } from './constants.js';
import { useChatPeople } from './hooks/use_chat_people.js';

const People = ({ filter }) => {
    const { people, findOrCreateConversation, isThinking, isFetching } = useChatPeople(filter);
    const somePeople = people.length > 0;
    const peopleCount = people.length;
    const childPeople = people.filter((p) => p.child);
    const someChildPeople = childPeople.length > 0;
    let title;
    switch (peopleCount) {
        case 0:
            title = "People selected";
            break;
        case 1:
            title = "1 person selected";
            break;
        default:
            title = `${peopleCount} people selected`;
    }
    return (React.createElement(StackView, { grow: 1 },
        React.createElement(StackView, { grow: 1, padding: 2, paddingBottom: 0, spacing: 1 },
            React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1 },
                React.createElement(Subheading, null, title),
                isFetching && React.createElement(Spinner, { size: "sm" })),
            somePeople ? (React.createElement(React.Fragment, null,
                someChildPeople && React.createElement(ChildNotice, { childPeople: childPeople }),
                React.createElement(ScrollContainer, null,
                    React.createElement(StackView, { paddingBottom: 2, spacing: 1.5 }, people.map((person) => (React.createElement(Person, { key: person.id, person: person }))))))) : (React.createElement(StackView, { alignment: "center", grow: 1, maxHeight: 18 },
                React.createElement(Text, { color: "foregroundSecondary" }, "No Results")))),
        React.createElement(NewChatViewFooter, { text: NEW_SERVICES_CHAT_FOOTER_TEXT, showSpinner: isThinking, buttonDisabled: !somePeople, onButtonClick: findOrCreateConversation })));
};

export { People };
//# sourceMappingURL=people.js.map
